export var SECONDS_TO_CLOSE_SNACK = 10;
